import { useState, useEffect } from 'react';
import apiManager from '../../ApiManager';
/* pocketlist>
pocket_lists_count
pocket_lists_created_at
pocket_lists_id
pocket_lists_name
pocket_lists_user
items:[pocket_list_items_id]
 */
export function usePocketlist(initValue) {
  const [pocketlist, setList] = useState(initValue);
  useEffect(() => {
  }, []);

  async function fetchAllData() {
    try {
      const _folders = await apiManager.fetchGet("pocket-list", {}, 100);
      for (var k in _folders) {
        const folder = _folders[k];
        folder.items = [];
        if (folder.pocket_lists_count > 0) {
          const _items = await apiManager.fetchGet(`pocket-list/${folder.pocket_lists_id}/items`, {}, 100);
          folder.items = _items;
        }
      }
      setList(_folders);
    } catch (error) {
      console.error("An error occurred:", error);
      setList([]);
    }
  }

  const updatePocketlist = (action, ...arg) => {
    switch (action) {
      case "init":
        fetchAllData();
        break;
      case "updateListName":
        updateListName(...arg);
        break;
      case "updateList":
        updateList(...arg);
        break;
      case "removeListItem":
        removeListItem(...arg);
        break;
      case "delList":
        delList(...arg);
        break;
      case "newList":
        newList(...arg);
        break;
      case "moveItem":
        moveItem(...arg);
        break;
      case "getListIdByRewildId":
        return getListIdByRewildId(...arg);
        break;
      case "addItem":
        addItem(...arg);
        break;
    }
  }
  /* pocketlist:[
  pocket_lists_count
pocket_lists_created_at
pocket_lists_id
pocket_lists_name
pocket_lists_user
items:[pocket_list_items_rewilding]
  ]
 */

  const updateList =async (listId) => {
    const updatedList = [...pocketlist];
    const list = updatedList.find(list => list.pocket_lists_id === listId);
      const _items = await apiManager.fetchGet(`pocket-list/${listId}/items`, {}, 0);
      list.items = _items;
    setList(updatedList);
  };
  const addItem = (listId,item) => {
    const updatedList = [...pocketlist];
    const list = updatedList.find(list => list.pocket_lists_id === listId);
    list.items.push(item);
    setList(updatedList);
  };
  const getListIdByRewildId = (rewildId) => {
    // 使用 filter 遍歷 pocketlist 找出包含 rewildId 的所有列表
    const foundLists = pocketlist.filter(list =>
      list.items.some(item => item.pocket_list_items_rewilding === rewildId)
    );

    // 返回所有符合條件的 pocket_lists_id
    return foundLists.map(list => list.pocket_lists_id);
  };

  const moveItem = (oriListId, itemId, desListId) => {
    const updatedList = [...pocketlist];

    // 找到原始列表（oriListId）
    const oriList = updatedList.find(list => list.pocket_lists_id === oriListId);
    if (oriList) {
      // 找到 itemId 對應的物件
      const itemObj = oriList.items.find(v => v.pocket_list_items_id === itemId);

      // 移除 itemId 從 oriList 的 items 中
      oriList.items = oriList.items.filter(item => item.pocket_list_items_id !== itemId);

      // 找到目標列表（desListId）並添加 itemObj
      const desList = updatedList.find(list => list.pocket_lists_id === desListId);
      if (desList && itemObj) {
        desList.items = [...desList.items, itemObj];
        setList(updatedList); // 更新列表狀態
      }
    }
  };

  const newList = (newFolder) => {
    newFolder.items = [];
    setList(updatedList => [...updatedList, newFolder]);
  };
  const delList = (listId) => {
    console.log("delList listId", listId)
    setList(updatedList => updatedList.filter(v => v.pocket_lists_id !== listId));
  };
  const updateListName = (listId, name) => {
    const updatedList = pocketlist.map(list =>
      list.pocket_lists_id === listId
        ? { ...list, pocket_lists_name: name }
        : list
    );
    setList(updatedList);
  };

  const removeListItem = (pocket_lists_id, items) => {
    const updatedList = [...pocketlist];
    const list = updatedList.find(v => v.pocket_lists_id === pocket_lists_id);
    if (list) {
      items.forEach(item => {
        const index = list.items.indexOf(item);
        if (index !== -1) {
          list.items.splice(index, 1);
        }
      });
      setList(updatedList);
    }
  };
  return [pocketlist, updatePocketlist];
}
